<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div id="etablissements" class="col-12 col-md-6">
            <h4 class="text-center">Etablissements</h4>
            <div class="table-container">
              <table v-if="etablissementsLoaded" class="table">
                <thead>
                  <tr>
                    <th>Établissement</th>
                    <th>Code analytique</th>
                    <th>Compte de charge</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="etablissement in etablissements"
                    :key="`etab_${etablissement.id}`"
                  >
                    <td width="35%">{{ etablissement.nom }}</td>
                    <td width="25%">
                      <input
                        class="form-control"
                        v-model="etablissement.code_analytique"
                        type="text"
                      />
                    </td>
                    <td width="25%">
                      <input
                        class="form-control"
                        v-model="etablissement.code_sage"
                        type="text"
                        maxlength="10"
                        placeholder="61354100"
                      />
                    </td>
                    <td class="td-actions text-right">
                      <button
                        @click="update(etablissement)"
                        class="btn btn-info btn-link btn-sm btn-icon edit"
                      >
                        <i class="fa fa-pen"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="!etablissements.length">
                    <td colspan="4" class="text-center">Aucun établissement trouvé.</td>
                  </tr>
                </tbody>
              </table>
              <vcl-table v-else :rows="4" :columns="3"></vcl-table>
            </div>
          </div>

          <div id="programmes" class="col-12 col-md-6">
            <h4 class="text-center">Programmes FC</h4>
            <div class="table-container">
              <table v-if="programmesLoaded" class="table">
                <tbody>
                  <tr
                    v-for="programme in programmes"
                    :key="`etab_${programme.id}`"
                  >
                    <td width="50%">{{ programme.nom }}</td>
                    <td width="30%">
                      <input
                        class="form-control"
                        v-model="programme.code_analytique"
                        type="text"
                      />
                    </td>
                    <td class="td-actions text-right">
                      <button
                        @click="updateProgramme(programme)"
                        class="btn btn-info btn-link btn-sm btn-icon edit"
                      >
                        <i class="fa fa-pen"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="!programmes.length">
                    <td class="text-center">Aucun programme trouvé.</td>
                  </tr>
                </tbody>
              </table>
              <vcl-table v-else :rows="4" :columns="2"></vcl-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      csrf_token: null,
      etablissements: [],
      etablissementsLoaded: null,
      programmes: [],
      programmesLoaded: null,
      element: null,
      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  methods: {
    update(etablissement) {
      axios
        .post(
          "/api/etablissements/code_analytique/update/" + etablissement.id,
          {
            code_analytique: etablissement.code_analytique,
            code_sage: etablissement.code_sage,
          },
          this.config
        )
        .then((response) => {
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Paramètres modifiés!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateProgramme(programme) {
      axios
        .post(
          "/api/programmes/code_analytique/update/" + programme.id,
          {
            code_analytique: programme.code_analytique,
          },
          this.config
        )
        .then((response) => {
          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Code analytique modifié!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.csrf_token = $('meta[name="csrf-token"]').attr("content");

    axios.get("/api/etablissements", this.config).then((res) => {
      this.etablissements = res.data;
      this.etablissementsLoaded = 1;
    });

    axios.get("/api/programmes", this.config).then((res) => {
      this.programmes = res.data;
      this.programmesLoaded = 1;
    });
  },
};
</script>
